<template>
  <r-simple-card title="Сортировка">
    <div class="map-sorting__container">
      <r-text type="caption" style="margin-bottom: 4px;">
        По атрибуту
      </r-text>
      <div class="map-sorting__control">
        <simple-attributes
          :id="id"
          field="field"
          :settings="layerStyle.order"
          :filter-id="0"
          type="number-time-string"
          :change-handler="changeSortField"
          :multiple="false"
        />
        <el-button
          size="mini"
          class="r-button icon-button"
          type="primary"
          circle
          plain
          @click="changeSortType"
          :disabled="!layerStyle.order.field"
        >
          <r-icon :name="sortIcon" :size="16" />
        </el-button>
      </div>
    </div>
  </r-simple-card>
</template>

<script>
import SimpleAttributes from "../../simple-attributes/simple-attributes";

export default {
  components: {
    SimpleAttributes
  },
  props: ["id", "layer-style", "layer-controller"],
  computed: {
    sortIcon() {
      return this.layerStyle.order.type === "asc"
        ? "sort-ascending"
        : "sort-descending";
    }
  },
  methods: {
    changeSortField() {
      this.layerController.handlers[this.id]();
    },
    changeSortType() {
      const { type } = this.layerStyle.order;
      const newValue = type === "asc" ? "desc" : "asc";

      this.$set(this.layerStyle.order, "type", newValue);

      this.changeSortField();
    }
  }
};
</script>

<style lang="scss">
.map-sorting {
  &__header {
    margin-bottom: 8px;
  }

  &__control {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .r-select {
      flex: 1;
    }

    .r-button {
      margin-left: 8px;
      flex-shrink: 0;
    }
  }
}
</style>
